define('CustomStockMessage.View',
    [
        'custom_stock_message.tpl',
        'jQuery',
        'SCView'
    ],
    function (
        custom_stock_message_tlp,
        jQuery,
        SCViewComponent
    ) {
        'use strict'
        var SCView = SCViewComponent.SCView;
        function CustomStockMessage(options) {

            SCView.call(this);

            this.options = options || {};

            this.template = custom_stock_message_tlp;

            this.initialize = function initialize(options) {
                this.container = options.container;
                var environment = this.container.getComponent('Environment');
                var pdp = this.container.getComponent('PDP');
                if (environment && pdp) {
                    var customStockMessageConfig = environment.getConfig('CustomStockMessage');
                    var itemInfo = pdp.getItemInfo();
                    if (customStockMessageConfig && itemInfo) {
                        var isUpperCase = customStockMessageConfig.isUpperCase;
                        var textToShow = customStockMessageConfig.textToShow;
                        this.textToShow = isUpperCase ? textToShow.toUpperCase() : textToShow;
                        this.linkToOpen = customStockMessageConfig.linkToOpen;

                        if (itemInfo.item) {
                            this.isCoreRequired = itemInfo.item.custitem_jc_corerequired || false;
                            if(itemInfo.item.storedisplayname2){
                                var storeDisplayName2Value = itemInfo.item.storedisplayname2.toUpperCase();
                                this.containOnStoreDisplay = storeDisplayName2Value.indexOf("MUST HAVE CORE") != -1 ? true : false;
                            }
                        }
                    }
                }
            }

            this.initialize(options);
        }

        CustomStockMessage.prototype = Object.create(SCView.prototype);

        CustomStockMessage.prototype.constructor = CustomStockMessage;

        CustomStockMessage.prototype.getContext = function getContext() {
            var showCustomSection = !!this.textToShow && !!this.linkToOpen && (this.isCoreRequired || this.containOnStoreDisplay);
            
            return {
                textToShow: this.textToShow,
                linkToOpen: this.linkToOpen,
                showCustomSection: showCustomSection
            };
        }

        return CustomStockMessage;
    }
);
